import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { FormMode, Client, Carrier, ClientMaster, RatingProfile, CarrierRateFile} from 'src/app/_models/models';
import { AlertService } from 'src/app/alert/alert.component';
import { ClientsService } from 'src/app/services/api/clients.service';
import { CarrierRateFilesService } from 'src/app/services/api/carrier-rate-files.service';
import { RatingProfilesService } from 'src/app/services/api/rating-profiles.service';
import { CarriersService } from 'src/app/services/api/carriers.service';
import { FormBuilder, FormControl, FormGroup, FormArray, NgForm } from '@angular/forms';
import { Router, RouterOutlet } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';
import { MessagePopupComponent } from 'src/app/Shared Components/message-popup/message-popup.component';
import { CommonService } from 'src/app/services/common.service';
import { ClientMasterService } from 'src/app/services/api/client-master.service';


@Component({
  selector: 'app-administration-client-index-component',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})

// https://stackoverflow.com/questions/55617772/angular-7-multiple-outlets-error-cannot-activate-an-already-activated-outle
export class AdministrationClientIndexComponent implements OnInit {
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  @ViewChild('callAPIDialog') callAPIDialog: TemplateRef<any>;
  clients: Client[];
  clientMasters: ClientMaster[];
  clientMaster: ClientMaster;
  //clientsCarrierRateFile: [];
  //clientsCarrierRateFileData : [];
  //carriers: SelectItem[];
  parentCarriers: SelectItem[] = new Array<SelectItem>();
  //carriers: SelectItem[] = new Array<SelectItem>();
  //rateFile: SelectItem[] = [];
  //selectedCity: any;
  //selected_carrier: Carrier;
  public tabledata : any[] = [];


  availableRateFiles = [];
  availableCarriers = [];
  availableRatingProfiles = [];


  //carriersFromAPI: any;
  clientMastersFromAPI: any;

  mode: FormMode = FormMode.None;
  formModes = FormMode;
  model: Client = new Client();
  showdiag: boolean = false;
  diagmsg: string;
  //selectedCarrier: any;
  //selectedParentCarrier: any;
  //selectedRateFile: string;
  //myFormGroup = new FormGroup({selectedCity1: new FormControl()});

  clientName: string;


  carriers: SelectItem[] = [
    { label: "FedEx", value: "FX" },
    { label: "GLS", value: "GLS" },
    { label: "UPS", value: "UPS" },
    { label: "Better Trucks", value: "BetterTrucks" },
    //{ label: "TLS Parcel", value: "TLS" },
    { label: "Lone Star Overnight", value: "LSO" },
    { label: "EasyPost", value: "EP" },
    { label: "GORI", value: "GORI" }
  ];

  public RateFileDtCols = [
    { field: 'Id', header: 'Id' },
    { field: 'Label', header: 'Label' },
    { field: 'FileOriginalName', header: 'Name' },
    { field: 'UploadedOn', header: 'Date' }
  ];

  public ShowMapping: boolean = false;
  // public isRateFileButtonDisplay : boolean = false;

  constructor(private carrierService: CarriersService, private clientService: ClientsService
    , private clientMasterService: ClientMasterService 
    , private rateFileService: CarrierRateFilesService, private ratingProfileService: RatingProfilesService, private alert: AlertService,
    public dialog: MatDialog, private _snackBar: MatSnackBar, private router: Router, private comm: CommonService, private fb: FormBuilder) {
  }
  displayedColumns: string[] = ['Name', 'APIKey','Actions'];
  ClientdataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator,{ static: false }) paginator: MatPaginator;
  //@ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild(MatSort) sort: MatSort;

  carriersForm: FormGroup;
  rateFilesForm: FormGroup;
  ratingProfilesForm: FormGroup;

  ngOnInit() {
    this.carriersForm = this.fb.group({
      clientCarriers: this.fb.array([])
    });
    this.rateFilesForm = this.fb.group({
      rateFiles: this.fb.array([])
    });
    //this.rateFilesForm.get('rateFiles').valueChanges.subscribe(row => { console.log('rateFiles', row) });
    this.ratingProfilesForm = this.fb.group({
      ratingProfiles: this.fb.array([])
    });

  }
  ngAfterViewInit() {
    this.loadListData();
    this.ClientdataSource.paginator = this.paginator;
  }
  openDialog() {    
    let dialogRef = this.dialog.open(this.callAPIDialog);
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result !== 'no') {
          const enabled = "Y"
          console.log(result);
        } else if (result === 'no') {
          console.log('User clicked no.');
        }
      }
    });
}
  onSend(form: NgForm){
  if(form.status === 'INVALID')
  {
    // display error in your form
  }else{
      console.log(form.value)
      this.dialog.closeAll(); // Close opened diaglo
    // do whatever you want to do with your data
}

}
  async loadListData() {
    //this._carrierRateFilesDiag = false;
    this.availableCarriers = new Array<SelectItem>();
    this.availableRateFiles = new Array<SelectItem>();
    this.availableRatingProfiles = new Array<SelectItem>();
    this.getRateFiles("");
    this.getCarriers(null);
    this.getRatingProfiles(null);
    this.clients = null;
    this.clientService.getAll(null).subscribe(
      r => {
        this.clients = new Array<Client>();
        for(let client of r){
          this.clients.push(client);
        }
        this.tabledata = this.clients;
        this.ClientdataSource = new MatTableDataSource(this.clients);
        this.ClientdataSource.paginator = this.paginator;

      },
      e => {
        this.openSnackBar('Failed to load carrier list', 'error');
      });
  }
  onChangedPageSize($event){
    console.log($event);
  }
  //toggleCarrierRateFilesDiag() {
  //  if (this._carrierRateFilesDiag) 
  //    this._carrierRateFilesDiag = false;
  //  else 
  //    this._carrierRateFilesDiag = true;   
  //}
  private _filter(value: any): any[] {
    const filterValue = value.toLowerCase();
    return this.availableCarriers.filter(option => option.label.toLowerCase().includes(filterValue));
  }
  get clientCarriers(): FormArray {
    return this.carriersForm.get('clientCarriers') as FormArray;
  }
  get rateFiles(): FormArray {
    return this.rateFilesForm.get('rateFiles') as FormArray;
  }
  get ratingProfiles(): FormArray {
    return this.ratingProfilesForm.get('ratingProfiles') as FormArray;
  }

  onSubmit(form: any) {
    switch (this.mode) {
      case FormMode.Find: {
        this.clientService.getAll(this.clientName).subscribe(
          r => {
            this.clients = new Array<Client>();
            for(let client of r){
              this.clients.push(client);
            }
            this.tabledata = this.clients;
            this.ClientdataSource = new MatTableDataSource(this.clients);
            this.ClientdataSource.paginator = this.paginator;
          },
          e => {
            this.openSnackBar('Failed to carrier list', 'error');
          });
        break;
      }
      case FormMode.New: {
        if (form.invalid) {
        } else {
          this.post(form);
        }
        break;
      }
      case FormMode.Edit: {
        if (form.invalid) {

        } else {
          this.put(form);
        }
        break;
      }
      case FormMode.Del: {
        this.delete(form);
        break;
      }
      default: {
        break;
      }
    }
  }
  post(form: any) {
//debugger;
    var id = this.model.clientMasterId;
    //var filteredCarrier =  this.carriersFromAPI.filter( s => s.id == this.selectedCarrier);
        this.clientService.create(this.model).subscribe(
      r => {
      form.resetForm();
      this.resetForm();
      this.loadListData();
      if ( r == null) {
        this.openSnackBar('Client with same name already exists', 'success');
      } else {
        this.openSnackBar('Saved sucessfully', 'success');
      }
      },
      e => function (ex) {
        this.openSnackBar('Failed to save', 'error');
      }
    );
  }

  put(form: any) {
    this.clientService.update(this.model).subscribe(result => {
      form.resetForm();
      this.resetForm();
      this.loadListData();
      this.openSnackBar('Updated sucessfully', 'success');
    }, error => {
      this.openSnackBar('Failed to update', 'error');

    });
  }

  delete(p: any) {
    //this.model = p;
    //this.model.selected = true;

    this.dialog
    .open(MessagePopupComponent, {
      data: {
        title: 'Delete Client',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        message: 'Are you sure you want to DELETE selected Client?',
      },
    })
    .afterClosed()
    .subscribe((res) => {
      if (res) {
        this.clientService.delete(p.id).subscribe(result => {
          this.resetForm();
          this.loadListData();
          this.openSnackBar('Deleted sucessfully', 'success');
        }, error => {
          this.openSnackBar('Failed to delete', 'error');
        });
        }
    });

  }

  resetForm() {
    this.loadListData();
    this.mode = FormMode.None;
    this.model.selected = false;
    this.model = new Client();
  }

  showFind() {
    this.mode = FormMode.Find;
    this.model.selected = false;
    this.model = new Client();
  }

  showNew() {
    //debugger;
    this.mode = FormMode.New;
    this.model.selected = false;
    // this.isRateFileButtonDisplay = false;
    this.model = new Client();
    this.clientCarriers.reset();
    this.rateFiles.reset();
    this.ratingProfiles.reset();
    this.clients = null;
    this.getClientMaster();
  }

  showEdit(p: any) {
    //debugger;
    this.getClient(p);
    // this.mode = FormMode.Edit;
    // this.model.selected = false;
    // this.model = p;
    // this.model.selected = true;
    // // this.isRateFileButtonDisplay = true;
    // localStorage.setItem('clientId', p.id.toString());
    // this.setFiles(p);
    // this.setCarriers(p);
    // this.setRatingProfiles(p);
    // this.getClientMaster();
  }

  showDel(p: any) {
    this.mode = FormMode.Del;
    this.model.selected = false;
    this.model = p;
    this.model.selected = true;
    this.setFiles(p);
  }

  getClient(model) {
    // this.availableRateFiles = [];
    this.clientService.get(model.id).subscribe(
      r => {
        this.mode = FormMode.Edit;
        this.model.selected = false;
        this.model = r;
        this.model.selected = true;
        // this.isRateFileButtonDisplay = true;
        localStorage.setItem('clientId', r.id.toString());
        this.setFiles(r);
        this.setCarriers(r);
        this.setRatingProfiles(r);
        this.getClientMaster();
      },
      e => {
        this.openSnackBar('Failed to get carrier rate files for the selected carrier', 'error');
      });
  }
  getClientMaster(){
    this.clientMasterService.getAll(null).subscribe(
      r => {
        this.clientMasters = new Array<ClientMaster>();
        this.clientMastersFromAPI=r;
        for (let clientMasterObj of r) {
          let c: ClientMaster = {
            id: clientMasterObj.id,
            name: clientMasterObj.name,
            billingContactID: clientMasterObj.billingContactID,
            billingID: clientMasterObj.billingID,
            billingDay: clientMasterObj.billingDay,
            billingFrequency: clientMasterObj.billingFrequency,
            netTerms: clientMasterObj.netTerms,
            lastBilled: clientMasterObj.lastBilled,
            apiKey: clientMasterObj.apiKey,
            active: clientMasterObj.active,
            selected: false

          };

          this.clientMasters.push({
            name: c.name, apiKey: c.apiKey, id: c.id, active: c.active
            , billingContactID: c.billingContactID, billingDay: c.billingDay
            , billingFrequency: c.billingFrequency, billingID: c.billingID
            , netTerms: c.netTerms, lastBilled: c.lastBilled
            , selected: false
          });
        }
      },
      e => {
        this.openSnackBar('Failed to get Client Master list', 'error');
      }
    );
  }



  //Rate Files
  getRateFiles(event)
  {
    this.availableRateFiles=[];
    this.rateFileService.getRateFiles(event).subscribe(
      r => {
        for (let file of r) {

          let RateFile: CarrierRateFile = {
            id: file.id,
            label: file.label,
            fileOriginalName: file.fileOriginalName,
            fileVersion: file.fileVersion,
            fileName: file.fileName,
            uploadedOn: file.uploadedOn,
            carrierCode: file.carrierCode,
            filePath: file.filePath,
            name: file.name,
            selected: false,
            ColList: [],
            ClientCarrierRateFiles: null,
            status: file.status,
            statusLog: file.statusLog,
            carrierRateSheet: null,
            carrierRate: null,
            serviceCodes: []
          };

          this.availableRateFiles.push({ label: file.label, value: RateFile });

        }
      },
      e => {
        this.openSnackBar('Failed to get carrier rate files for the selected carrier', 'error');
      });
  }
  private setFiles(p) {
    const rateFileFGs = p.carrierRateFiles.map(element => this.fb.group({
      carrierCode: new FormControl(this.availableRateFiles.find(x=> x.value.id == element.carrierRateFileId).value.carrierCode),
      carrierRateFileId: new FormControl(element.carrierRateFileId),
      carrierRateFile: new FormControl(element.carrierRateFile),
      id: new FormControl(element.id),
      clientId: new FormControl(parseInt(localStorage.getItem('clientId'))),
      client: new FormControl (null),
      selected: new FormControl(false)
    }));
    const rateFileFormArray = this.fb.array(rateFileFGs);
    this.rateFilesForm.setControl('rateFiles', rateFileFormArray);

  }
  addRateFile() {
    var newRow = {
      carrierCode: new FormControl (""),
      carrierRateFileId: new FormControl (null),
      carrierRateFile: new FormControl(null),
      id: new FormControl(0),
      clientId: new FormControl (parseInt(localStorage.getItem('clientId'))),
      client: new FormControl (null),
      selected: new FormControl(false)
    };
    this.rateFiles.push(this.fb.group(newRow));
  }
  saveRateFile(element)
  {
    var clientId = localStorage.getItem('clientId');
    let req = {
      CarrierCode: element.controls["carrierCode"].value,
      ClientId: clientId,
      CarrierRateFileId: element.controls["carrierRateFileId"].value,
      Id: element.controls["id"].value
    };
    if (element.value.id > 0) {
      this.rateFileService.updateMappedClientRateFile(req).subscribe(
        r => {
          this.openSnackBar('Saved sucessfully', 'success');
        },
        e => {
          this.openSnackBar('Failed to save mapping', 'error');
        });
    }
    else {
      this.rateFileService.mapClientRateFile(req).subscribe(
        r => {
          this.openSnackBar('Saved sucessfully', 'success');
        },
        e => {
          this.openSnackBar('Failed to save mapping', 'error');
        });
    }
  }
  removeRateFile(index) {
    var data = this.rateFiles.controls[index].value;

    if (data.id > 0) {
    this.dialog
      .open(MessagePopupComponent, {
        data: {
          title: 'Unmap Rate File',
          confirmText: 'Remove',
          cancelText: 'No',
          message: 'Are you sure you want to remove this rate file from the selected client?',
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const carrierRateFileIdValue = data.carrierRateFileId;
          this.rateFileService.deleteMappedClientRateFile(data.clientId, carrierRateFileIdValue).subscribe(result => {
            this.openSnackBar('Rate file removed successfully', 'success');
            this.rateFiles.removeAt(index);
          }, error => {
            this.openSnackBar('Failed to remove rate file', 'error');
          });
        }
      });
    }
    else {
      this.rateFiles.removeAt(index);
    }
  }
  getRateFilesForCarrier(element) {
    if (element.value.carrierCode != null && element.value.carrierCode.length > 0)
      return this.availableRateFiles.filter(x => x.value.carrierCode == element.value.carrierCode);
    else
      return this.availableRateFiles;
  }


  //Carriers
  getCarriers(event) {

    //var filteredCarrier = this.carriersFromAPI.filter(s => s.id == event.value);
    //localStorage.setItem('carrierId', event.value.toString());
    this.availableCarriers = [];
    this.carrierService.getAll(event).subscribe(
      r => {
        for (let rec of r) {

          let carrier: Carrier = {
            id: rec.id,
            accountNumber: rec.accountNumber,
            apiAccessKey: rec.apiAccessKey,
            apiPassword: rec.apiPassword,
            apiUsername: rec.apiUsername,
            engine: rec.engine,
            name: rec.name,
            trackingFormat: 0,
            isMultiCarrier: rec.isMultiCarrier,
            childAccounts: rec.childAccounts,
            selected: false
          };

          this.availableCarriers.push(carrier);

        }
      },
      e => {
        this.openSnackBar('Failed to get carriers', 'error');
      });
  }
  private setCarriers(p) {
    for (let clientCarrier of p.carriers) {
      for (let carrier_selectItem of this.availableCarriers) {

        if (carrier_selectItem.label == "None" || carrier_selectItem.id != clientCarrier.carrierId) {
          //SKIP
        } else {
          clientCarrier.hasChildAccounts = carrier_selectItem.childAccounts.length > 0;
          clientCarrier.availableChildAccounts = carrier_selectItem.childAccounts;

          break;
        }
      }
    }

    const carrierFGs = p.carriers.map(element => this.fb.group(element));
    const carrierFormArray = this.fb.array(carrierFGs);
    this.carriersForm.setControl('clientCarriers', carrierFormArray);
  }
  addCarrier() {
    var newRow = {
      carrier: new FormControl (null),
      carrierId: new FormControl (0),
      childAccount: new FormControl (null),
      childAccountId: new FormControl (0),
      carrierCode: new FormControl (""),
      childCarrier: new FormControl (""),
      bypassRateValidation: new FormControl (false),
      client: new FormControl (null),
      clientId: new FormControl (parseInt(localStorage.getItem('clientId'))),
      immediatePayments: new FormControl (false),
      //noMarkups: new FormControl (false),
      transactionFee: new FormControl (0),
      transactionFeePercentage: new FormControl (0),
      selected: new FormControl(true)
    };
    this.clientCarriers.push(this.fb.group(newRow));
  }
  saveCarrier(selectedCarrier, value) {
    //var filteredCarrier = this.availableCarriers.filter(s => s.id == selectedCarrier.value.carrierId);

    var clientId = localStorage.getItem('clientId');
    let req = {
      ClientId: clientId,
      CarrierId: selectedCarrier.value.carrierId,
      SkipInvoiceImport: selectedCarrier.value.immediatePayments,
      BypassRateValidation: selectedCarrier.value.bypassRateValidation,
      //NoMarkups: selectedCarrier.value.noMarkups,
      TransactionFee: selectedCarrier.value.transactionFee,
      TransactionFeePercentage: selectedCarrier.value.transactionFeePercentage,
      ChildAccountId: selectedCarrier.value.childAccountId > 0 ? selectedCarrier.value.childAccountId : null,
      ChildCarrier: selectedCarrier.value.childCarrier,
      Id: selectedCarrier.value.id
    }
    //var selectedCarrier = value.find(s => s.label == selectedCarrier);
    //if (filteredCarrier[0].noMarkup && (selectedCarrier == null || selectedCarrier == undefined)) {
    //  alert("Select Carrier rate file");
    //}

    //if (selectedCarrier != null && selectedCarrier != "" && selectedCarrier != undefined && selectedCarrier != null && selectedCarrier != "") {
    //  req.CarrierId = selectedCarrier.value.Id;
    //}
    //this.ClientdataSource.paginator = this.paginator;
    this.carrierService.mapCarrier(req).subscribe(
      r => {
        this.openSnackBar('Saved sucessfully', 'success');
      },
      e => {
        this.openSnackBar('Failed to save mapping', 'error');
      });

  }
  removeCarrier(index) {
    var data = this.clientCarriers.value[index]

    if (data.id > 0) {
    this.dialog
      .open(MessagePopupComponent, {
        data: {
          title: 'Unmap Carrier',
          confirmText: 'Remove',
          cancelText: 'No',
          message: 'Are you sure you want to remove this carrier from the selected client?',
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const carrierCarrierIdValue = data.carrierCarrier?.id ?? 0;
          this.carrierService.deleteMappedCarrier(data.clientId, data.carrierId, data.childCarrier).subscribe(result => {
            this.openSnackBar('Carrier removed successfully', 'success');
            this.clientCarriers.removeAt(index);
          }, error => {
            this.openSnackBar('Failed to remove carrier', 'error');
          });
        }
      });
    }
    else {
      this.clientCarriers.removeAt(index);
    }

  }
  hasChildAccounts(carrierId) {
    if (carrierId != null && carrierId > 0) {
      let carrier = this.availableCarriers.filter(x => x.id == carrierId);
      if (carrier != null && carrier.length > 0) {
        return carrier[0].childAccounts.length > 0;
      }
    }
    return false;
  }
  getChildAccounts(carrierId): any[] {
    if (carrierId != null && carrierId > 0) {
      let carrier = this.availableCarriers.filter(x => x.id == carrierId);
      if (carrier != null && carrier.length > 0) {
        return carrier[0].childAccounts;
      }
    }
    return [];
  }


  //RatingProfiles
  getRatingProfiles(event) {

    //var filteredRatingProfile = this.ratingProfilesFromAPI.filter(s => s.id == event.value);
    //localStorage.setItem('ratingProfileId', event.value.toString());
    this.availableRatingProfiles = [];
    this.ratingProfileService.getAll(event).subscribe(
      r => {
        for (let rec of r) {

          let ratingProfile: RatingProfile = {
            id: rec.id,
            description: rec.description,
            createdAt: rec.createdAt,
            modifiedAt: rec.modifiedAt,
            selected: rec.selected,
            profileName: rec.profileName,
            accessorialDiscounts: rec.accessorialDiscounts,
            serviceDiscounts: rec.serviceDiscounts
          };

          this.availableRatingProfiles.push(ratingProfile);

        }
      },
      e => {
        this.openSnackBar('Failed to get ratingProfiles', 'error');
      });
  }
  private setRatingProfiles(p) {
    let flag = true;
    const ratingProfileFGs = p.ratingProfiles.map(element => this.fb.group(element));
    const ratingProfileFormArray = this.fb.array(ratingProfileFGs);
    this.ratingProfilesForm.setControl('ratingProfiles', ratingProfileFormArray);
  }
  addRatingProfile() {
    let newRow = {
      ratingProfile: new FormControl (null),
      ratingProfileId: new FormControl (0),
      client: new FormControl (null),
      clientId: new FormControl (parseInt(localStorage.getItem('clientId'))),
      isActive: new FormControl (true),
      selected: new FormControl(true),
      id: new FormControl(0)
    };
    this.ratingProfiles.push(this.fb.group(newRow));
  }
  saveRatingProfile(selectedRatingProfile) {
    if (selectedRatingProfile == null) {
      alert("Select RatingProfile rate file");
      return;
    }
    var filteredRatingProfile = this.availableRatingProfiles.filter(s => s.id == selectedRatingProfile.controls["ratingProfileId"].value);

    var clientId = localStorage.getItem('clientId');
    let req = {
      //RatingProfileCode: selectedRatingProfile,
      ClientId: clientId,
      RatingProfileId: filteredRatingProfile[0].id,
      Id: selectedRatingProfile.value.id
    }

    if (selectedRatingProfile.value.id > 0) {
      this.ratingProfileService.updateMappedRatingProfile(req).subscribe(
        r => {
          this.openSnackBar('Saved sucessfully', 'success');
        },
        e => {
          this.openSnackBar('Failed to save mapping', 'error');
        });
    }
    else {
      //this.ClientdataSource.paginator = this.paginator;
      this.ratingProfileService.mapRatingProfile(req).subscribe(
        r => {
          this.openSnackBar('Saved sucessfully', 'success');
        },
        e => {
          this.openSnackBar('Failed to save mapping', 'error');
        });
    }

  }
  removeRatingProfile(index) {
    var data = this.ratingProfiles.controls[index].value

    if (data.id > 0) {
    this.dialog
      .open(MessagePopupComponent, {
        data: {
          title: 'Unmap Rating Profile',
          confirmText: 'Remove',
          cancelText: 'No',
          message: 'Are you sure you want to remove this rating profile from the selected client?',
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const ratingProfileRatingProfileIdValue = data.ratingProfileId;
          this.ratingProfileService.deleteMappedRatingProfile(data.clientId, ratingProfileRatingProfileIdValue).subscribe(result => {
            this.openSnackBar('Rating profile removed successfully', 'success');
            this.ratingProfiles.removeAt(index);
          }, error => {
            this.openSnackBar('Failed to remove rating profile', 'error');
          });
        }
      });
    }
    else {
      this.ratingProfiles.removeAt(index);
    }
  }

  openSnackBar(message: string, messageType:'error'|'success'|'notification') {
    let config = new MatSnackBarConfig();
    config.data = {
      message: message,
      type:messageType
    };
    config.duration = environment.messageTimeOut;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass =messageType;
    this._snackBar.openFromComponent(SnackbarComponent, config);
  }

  close(){
    this.dialog.closeAll();
    this.ClientdataSource = new MatTableDataSource(this.tabledata);
    this.ClientdataSource.paginator = this.paginator;
   }

}
